import moment from "moment";
import React from "react";
import { Spinner } from "react-rainbow-components";
import { GetErrorMessage } from "../../functions/error";
import { IPaymentTracking } from "../../interfaces/paymentTracking";
import { IPets } from "../../interfaces/pets";
import { makeDoneBooking, updateBooking } from "../../services/booking.service";
import { useError } from "../../store/ErrorModal";
import InputTags from "../common/InputTags";
import {
  AvatarProfile,
  Button,
  ContainerCard,
  ContainerDetailProfile,
  ContainerHeaderCard,
  Detail,
  Textarea,
  TitleDetail,
} from "./CardSummary.style";
interface ICardSummary {
  isLoading?: boolean;
  booking?: IPaymentTracking;
  handleChangeTage: (tags: string[]) => void;
  handleSubmit: () => void;
  setIsLoading?: (isLoading: boolean) => void;
}
export const CardSummary = (props: ICardSummary) => {
  const [initTags, setInitTags] = React.useState<string[]>([]);
  const [summary, setSummary] = React.useState<string>("");
  const { onError } = useError();

  const getPet = (pets: IPets[], pid: string) =>
    pets.find((pet) => pet.pid === pid);
  React.useEffect(() => {
    setInitTags(props.booking?.summaryTags || []);
  }, [props.booking]);
  const handleChangeSummary = (event: React.ChangeEvent<{ value: string }>) =>
    setSummary(event.target.value);

  const handleSubmit = async () => {
    props.setIsLoading && props.setIsLoading(true);
    if (!props.booking?.bookingId) return onError("มีบางอย่างผิดพลาด");
    try {
      await makeDoneBooking(props.booking?.bookingId, { summary });
      setSummary("");
      props.handleSubmit();
    } catch (error: any) {
      onError(GetErrorMessage(error));
    }
    props.setIsLoading && props.setIsLoading(false);
  };
  const handleChangeTage = async (tags: string[], bookingId: string) => {
    try {
      await updateBooking(bookingId, {
        summaryTags: tags,
      });
    } catch (error: any) {
      onError(GetErrorMessage(error));
    }
    props.handleChangeTage(tags);
  };
  return (
    <ContainerCard className="bg-card">
      {props.isLoading ? (
        <Spinner />
      ) : props.booking && props.booking !== undefined ? (
        <>
          <ContainerHeaderCard>
            <AvatarProfile
              alt="profile-image-avatar"
              src={props.booking.imageUrl}
            />
            <ContainerDetailProfile>
              {/* User Detail */}
              <h2 className="text-n-color">{props.booking.displayName}</h2>
              <p className="text-h-color">
                สัตว์เลี้ยง:{" "}
                {getPet(props.booking.pets || [], props.booking.pid)?.petType}{" "}
                ชื่อ:{" "}
                {getPet(props.booking.pets || [], props.booking.pid)?.petName}
              </p>
            </ContainerDetailProfile>
          </ContainerHeaderCard>
          <TitleDetail className="text-n-color">ลักษณะอาการ</TitleDetail>
          {/* Descriptions */}
          <Detail className="text-h-color">{props.booking.descriptions}</Detail>
          <TitleDetail className="text-n-color">เพิ่มแท็ก</TitleDetail>
          <InputTags
            initTags={initTags}
            onChange={async (newValue) => {
              const tags = newValue.map((tag) => tag.value);
              props.booking && handleChangeTage(tags, props.booking.bookingId);
            }}
          />
          <TitleDetail className="text-n-color">วันที่สิ้นสุดงาน</TitleDetail>
          <p className="text-h-color">
            {moment(props.booking.endDate).format("DD/MM/YYYY")}
          </p>
          <TitleDetail className="text-n-color">สรุปอาการ</TitleDetail>
          <Textarea
            placeholder="เพิ่มคำอธิบาย..."
            value={summary}
            onChange={handleChangeSummary}
          />
          <Button onClick={handleSubmit}>บันทึก</Button>
        </>
      ) : (
        <p
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "1.5rem",
            margin: "auto 0rem",
          }}
        >
          ไม่มีเคสที่กำลังดูแล
        </p>
      )}
    </ContainerCard>
  );
};
